module.exports = __webpack_public_path__ + "img/10_52.c5a5d3e2.png";